import {Workorder} from './workorder';
import {Role} from './role.class';
import {Customer} from './customer';

export class User {
    id: number;
    id_4ps?: string;
    initials?: string;
    name: string;
    email: string;
    hasOtp: boolean;
    email_ticket_notifications?: boolean;
    created_at: Date;
    workorders?: Workorder[];
    roles?: Role[];
    customers?: Customer[];
}
